// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-list-page {
  margin-top: 10vh;
  margin: 10vh;
  background: #ffffff;
  color: #000000;
  padding: 2rem 1.5rem;
}

.product-list-page .container {
  margin: 0 auto;
  padding: 0 !important;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.product-list-header {
  margin-bottom: 2.5rem;
  text-align: center;
}

.header-content h1 {
  font-size: clamp(2rem, 4vw, 3rem);
  margin: 0.5rem 0 0.4rem;
  color: #000000;
  line-height: 1.1;
}

.header-content p {
  margin: 0;
  color: #333333;
  font-size: 1rem;
}

.loading-state,
.empty-state {
  text-align: center;
  color: #333333;
  padding: 4rem 1rem;
}

.spinner {
  width: 48px;
  height: 48px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top-color: #000000;
  border-radius: 999px;
  margin: 0 auto 1.5rem;
  animation: spin 0.9s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.products-grid {
  max-width: 100%;
  margin: 0 auto;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 1.5rem;
  margin-bottom: 3rem;
}

.product-card {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #000000;
  background: #ffffff;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  transition: all 0.3s ease;
}

.product-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  border-color: #000000;
}

.product-image {
  position: relative;
  height: 200px;
  overflow: hidden;
  background: #e0e0e0;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.product-card:hover .product-image img {
  transform: scale(1.05);
}

.image-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.product-card:hover .image-overlay {
  opacity: 1;
}

.image-overlay span {
  color: #fff;
  font-weight: 600;
  font-size: 0.95rem;
}

.product-info {
  padding: 1rem;
}

.product-info h3 {
  margin: 0 0 0.5rem;
  font-size: 1rem;
  color: #000000;
  line-height: 1.3;
  font-weight: 600;
}

.product-description {
  margin: 0;
  color: #333333;
  font-size: 0.85rem;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

@media (max-width: 768px) {
  .products-grid {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 1rem;
  }

  .product-list-header {
    margin-bottom: 1.5rem;
  }

  .header-content h1 {
    font-size: 1.8rem;
  }

  .back-button {
    margin-bottom: 1.5rem;
  }
}

@media (max-width: 480px) {
  .products-grid {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 0.75rem;
  }

  .product-list-page .container {
    padding: 0 1rem;
  }

  .product-image {
    height: 140px;
  }

  .product-info {
    padding: 0.8rem;
  }

  .product-info h3 {
    font-size: 0.85rem;
  }

  .product-description {
    font-size: 0.75rem;
  }
  .products-grid {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 0.75rem;
  }

  .product-list-page .container {
    padding: 0 1rem;
  }

  .product-image {
    height: 140px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/product-list.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,UAAU;EACV,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE;IACE,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,4DAA4D;IAC5D,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;EAIA;IACE,4DAA4D;IAC5D,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AAdF","sourcesContent":[".product-list-page {\n  margin-top: 10vh;\n  margin: 10vh;\n  background: #ffffff;\n  color: #000000;\n  padding: 2rem 1.5rem;\n}\n\n.product-list-page .container {\n  margin: 0 auto;\n  padding: 0 !important;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.product-list-header {\n  margin-bottom: 2.5rem;\n  text-align: center;\n}\n\n.header-content h1 {\n  font-size: clamp(2rem, 4vw, 3rem);\n  margin: 0.5rem 0 0.4rem;\n  color: #000000;\n  line-height: 1.1;\n}\n\n.header-content p {\n  margin: 0;\n  color: #333333;\n  font-size: 1rem;\n}\n\n.loading-state,\n.empty-state {\n  text-align: center;\n  color: #333333;\n  padding: 4rem 1rem;\n}\n\n.spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-top-color: #000000;\n  border-radius: 999px;\n  margin: 0 auto 1.5rem;\n  animation: spin 0.9s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.products-grid {\n  max-width: 100%;\n  margin: 0 auto;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 3rem;\n}\n\n.product-card {\n  border-radius: 12px;\n  overflow: hidden;\n  border: 1px solid #000000;\n  background: #ffffff;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n  transition: all 0.3s ease;\n}\n\n.product-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\n  border-color: #000000;\n}\n\n.product-image {\n  position: relative;\n  height: 200px;\n  overflow: hidden;\n  background: #e0e0e0;\n}\n\n.product-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n.product-card:hover .product-image img {\n  transform: scale(1.05);\n}\n\n.image-overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.product-card:hover .image-overlay {\n  opacity: 1;\n}\n\n.image-overlay span {\n  color: #fff;\n  font-weight: 600;\n  font-size: 0.95rem;\n}\n\n.product-info {\n  padding: 1rem;\n}\n\n.product-info h3 {\n  margin: 0 0 0.5rem;\n  font-size: 1rem;\n  color: #000000;\n  line-height: 1.3;\n  font-weight: 600;\n}\n\n.product-description {\n  margin: 0;\n  color: #333333;\n  font-size: 0.85rem;\n  line-height: 1.5;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n@media (max-width: 768px) {\n  .products-grid {\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    gap: 1rem;\n  }\n\n  .product-list-header {\n    margin-bottom: 1.5rem;\n  }\n\n  .header-content h1 {\n    font-size: 1.8rem;\n  }\n\n  .back-button {\n    margin-bottom: 1.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .products-grid {\n    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n    gap: 0.75rem;\n  }\n\n  .product-list-page .container {\n    padding: 0 1rem;\n  }\n\n  .product-image {\n    height: 140px;\n  }\n\n  .product-info {\n    padding: 0.8rem;\n  }\n\n  .product-info h3 {\n    font-size: 0.85rem;\n  }\n\n  .product-description {\n    font-size: 0.75rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .products-grid {\n    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n    gap: 0.75rem;\n  }\n\n  .product-list-page .container {\n    padding: 0 1rem;\n  }\n\n  .product-image {\n    height: 140px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
